import { FieldErrors } from 'react-hook-form';

import { IEventForm } from 'interfaces/event';
import { create } from 'zustand';

type StoreState = {
  isCreateEvent: boolean;
  setIsCreateEvent: (isCreateEvent: boolean) => void;
  formErrors: FieldErrors<IEventForm & { isCreate: boolean }>;
  setFormErrors: (formErrors: FieldErrors<IEventForm & { isCreate: boolean }>) => void;
};

export const useEventStore = create<StoreState>(set => ({
  isCreateEvent: false,
  setIsCreateEvent: (isCreateEvent: boolean) => set(() => ({ isCreateEvent })),
  formErrors: {},
  setFormErrors: (formErrors: FieldErrors<IEventForm & { isCreate: boolean }>) => set(() => ({ formErrors }))
}));

export default useEventStore;
